"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupChatSocketHideObservable = void 0;
const mappers_1 = require("../../mappers");
const models_1 = require("../../models");
const socket_1 = require("../../socket");
const Observable_1 = require("../../socket/Observable");
const DomainEvents_1 = require("../../utils/DomainEvents");
const utils_1 = require("../../utils");
class GroupChatSocketHideObservable {
    constructor(chatsStorage, httpAdapter, organizationUser, socketAdapter, userDirectory) {
        this.chatsStorage = chatsStorage;
        this.httpAdapter = httpAdapter;
        this.organizationUser = organizationUser;
        this.organization = organizationUser.getOrganization();
        this.socketAdapter = socketAdapter;
        this.userDirectory = userDirectory;
    }
    hideChatListener(cb, groupType) {
        return Observable_1.Observable.getInstance().subscribe((0, DomainEvents_1.getEventKey)(socket_1.DomainEvents.HIDE_CHAT, this.organization.organizationId), (data) => {
            if (data.groupType !== groupType) {
                return;
            }
            this.moveToChats(data, models_1.GROUP_TYPE.HIDDEN, data.groupType);
            //Notify hidden group of the change
            Observable_1.Observable.getInstance().notify((0, DomainEvents_1.groupEventKey)(this.organization.organizationId, models_1.GROUP_TYPE.HIDDEN), this.chatsStorage.getChatListByType(models_1.GROUP_TYPE.HIDDEN));
            cb(this.getChats(data.groupType));
        });
    }
    unHideChatListener(cb, groupType) {
        return Observable_1.Observable.getInstance().subscribe((0, DomainEvents_1.getEventKey)(socket_1.DomainEvents.UNHIDE_CHAT, this.organization.organizationId), (data) => {
            if (data.groupType !== groupType) {
                return;
            }
            this.moveToChats(data, data.groupType, models_1.GROUP_TYPE.HIDDEN);
            //Notify hidden group of the change
            Observable_1.Observable.getInstance().notify((0, DomainEvents_1.groupEventKey)(this.organization.organizationId, models_1.GROUP_TYPE.HIDDEN), this.chatsStorage.getChatListByType(models_1.GROUP_TYPE.HIDDEN));
            cb(this.getChats(data.groupType));
        });
    }
    hideUnHideChat(data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.httpAdapter.getChatAdapter().hideUnHideGroup(data);
            }
            catch (e) {
                throw new utils_1.HhnException(e);
            }
        });
    }
    moveToChats(data, moveToGroupType, moveFromGroupType) {
        // Get chat by chatId from patient/non-patient chatList
        let chat = this.chatsStorage.getChatByGroupType(moveFromGroupType, data.from);
        if (chat) {
            // Remove chat from patient/non-patient chat list according to group type
            const chatList = this.chatsStorage.deleteChat(moveFromGroupType, chat.id);
            // Update search match count if searching
            if (chatList.searchMatchCount) {
                chatList.searchMatchCount -= 1;
            }
            if (chat.unreadCount > 0) {
                chatList.unreadChatCount -= 1;
            }
            this.chatsStorage.setChatListByType(moveFromGroupType, chatList);
        }
        else {
            chat = (0, mappers_1.groupChatMapper)(data, this.userDirectory, this.organizationUser, this.httpAdapter);
        }
        this.chatsStorage.addChatToChatList(moveToGroupType, chat);
    }
    getChats(groupType) {
        return this.chatsStorage.getChatListByType(groupType);
    }
}
exports.GroupChatSocketHideObservable = GroupChatSocketHideObservable;
